import React, { createContext, useState, useContext, useEffect } from "react";
import {
  login as accountLogin,
  logout as accountLogout,
  resetPassword as accountResetPassword,
  createUser as accountCreateUser,
  checkAuthStatus as accountCheckAuthStatus,
} from "../services/AccountService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      const { isAuthenticated, user } = await accountCheckAuthStatus();
      if (isAuthenticated) {
        setUser(user);
        setIsLoggedIn(true);
      }
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const result = await accountLogin(email, password);
      console.log('Login service result:', result);
      
      if (result.success) {
        setUser(result.user);
        setIsLoggedIn(true);
        return {
          success: true,
          message: result.message
        };
      }
      
      return {
        success: false,
        error: result.error
      };
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        error: 'Login failed. Please try again.'
      };
    }
  };

  const logout = async () => {
    await accountLogout();
    setIsLoggedIn(false);
    setUser(null);
  };

  const resetPassword = async (currentPassword, newPassword) => {
    if (!user?.email) return { success: false, error: "No user logged in" };

    const result = await accountResetPassword(
      user.email,
      currentPassword,
      newPassword
    );

    if (result.success) {
      // Optionally update user session/token if needed
      return { success: true, message: "Password updated successfully" };
    }

    return {
      success: false,
      error: result.error || "Failed to update password",
    };
  };

  const addAuthorizedUser = async (email, fullName) => {
    if (!user?.role || user.role !== "superadmin") {
      return { success: false, error: "Unauthorized" };
    }

    // Generate a secure temporary password
    const tempPassword = Math.random().toString(36).slice(-8) + "A1!";

    const result = await accountCreateUser({
      email,
      fullName,
      password: tempPassword,
      role: "admin",
    });

    if (result.success) {
      return {
        success: true,
        tempPassword,
        message: "User created successfully",
      };
    }

    return {
      success: false,
      error: result.error || "Failed to create user",
    };
  };

  const removeAuthorizedUser = async (email) => {
    if (!user?.role || user.role !== "superadmin") {
      return { success: false, error: "Unauthorized" };
    }

    // Prevent removing superadmin users
    if (email === "josh@zetacoms.com" || email === "walexy85@gmail.com") {
      return { success: false, error: "Cannot remove superadmin users" };
    }

    // Implementation will depend on your backend logic
    // For now, returning success as we haven't implemented delete functionality
    return { success: true, message: "User removed successfully" };
  };

  const checkUserRole = (allowedRoles) => {
    if (!user) return false;
    return allowedRoles.includes(user.role);
  };

  const value = {
    user,
    isLoggedIn,
    loading,
    login,
    logout,
    resetPassword,
    addAuthorizedUser,
    removeAuthorizedUser,
    checkUserRole,
    setIsLoggedIn,
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0C60F2]"></div>
      </div>
    );
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

// import React, { createContext, useState, useContext, useEffect } from 'react';
// import {
//   login as accountLogin,
//   logout as accountLogout,
//   //resetPassword as accountResetPassword,
//   checkAuthStatus as accountCheckAuthStatus,
//   validateSession as accountValidateSession
// } from '../services/AccountService';

// const AuthContext = createContext(null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const initializeAuth = async () => {
//       const { isAuthenticated, user } = await accountCheckAuthStatus();
//       if (isAuthenticated) {
//         setUser(user);
//       }
//       setLoading(false);
//     };

//     initializeAuth();
//   }, []);

//   const login = async (email, password) => {
//     const result = await accountLogin(email, password);
//     if (result.success) {
//       setUser(result.user);
//       setIsLoggedIn(true);
//       return true;
//     }
//     return false;
//   };

//   const logout = async () => {
//     await accountLogout();
//     setIsLoggedIn(false);
//     setUser(null);
//   };

//   // const changePassword = async (currentPassword, newPassword) => {
//   //   if (!user?.email) return false;

//   //   const result = await accountResetPassword(currentPassword, newPassword);
//   //   return result.success;
//   // };

//   const addAuthorizedUser = async (email, fullName) => {
//     if (!user || user.role !== 'superadmin') return false;

//     // Generate a temporary password
//     const tempPassword = Math.random().toString(36).slice(-8) + 'A1!';

//     // Using the login endpoint to create user
//     const result = await accountLogin(email, tempPassword);

//     if (result.success) {
//       return tempPassword;
//     }
//     return false;
//   };

//   const value = {
//     user,
//     login,
//     logout,
//     isLoggedIn,
//     setIsLoggedIn,
//     //changePassword,
//     addAuthorizedUser,
//     loading
//   };

//   if (loading) {
//     return <div className="min-h-screen flex items-center justify-center">
//       <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0C60F2]"></div>
//     </div>;
//   }

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };
